import React from 'react';
import { KeyBindingUtil } from 'draft-js';
import { isWindows } from '@support/platform-checks';

function buildMetaSymbol() {
  if (isWindows()) {
    return 'CTRL';
  }
  return '⌘';
}

export function metaTrigger(e) {
  return KeyBindingUtil.hasCommandModifier(e);
}

export const metaSymbol = buildMetaSymbol();

export function isUpHandler(e: React.KeyboardEvent): boolean {
  return (
    !metaTrigger(e) &&
    (e.key === 'ArrowUp' ||
      e.key === 'k' ||
      (e.shiftKey && e.key == 'Tab') ||
      (e.ctrlKey && e.key === 'p'))
  );
}

export function isDownHandler(e: React.KeyboardEvent): boolean {
  return (
    (!metaTrigger(e) && e.key === 'ArrowDown') ||
    e.key === 'j' ||
    e.key == 'Tab' ||
    (e.ctrlKey && e.key === 'n')
  );
}

export function targetIsTextInput(e: KeyboardEvent): boolean {
  const target = e.target as HTMLInputElement;
  return (
    target.matches('input') || target.matches('textarea') || target.hasAttribute('contenteditable')
  );
}

// The only two cases where we want to allow event bubbling from a text field
// keyboard event:
// 1. Escape key to navigate, but only if the text field is empty. Otherwise, we
//    blur the input and stop bubbling.
// 2. Cmd-enter to save view state.
export function stopKeyboardEventBubbling(e: KeyboardEvent): boolean {
  const target = e.target as HTMLInputElement;

  if (e.defaultPrevented) {
    return true;
  }

  switch (e.key) {
    case 'Enter':
      if (metaTrigger(e)) {
        return false;
      }
      return true;

    case 'Escape':
      if (target.value != '') {
        target.blur?.();
        return true;
      }
      return false;

    default:
      return true;
  }
}
